module.exports = __webpack_public_path__ + "static/media/profile-image-placeholder.b60a3334.svg";